import React from "react";
import { Typography, Tooltip } from "@mui/material";
import InfoRoundedIcon from '@mui/icons-material/InfoRounded';

import styles from "./index.module.scss";

const Body2 = ({
	text,
	extraClass,
	error,
	fontType,
	fontStyle,
	isLink,
	handleClick,
	enableInfo = false,
	infoText = ""
}) => {
	const customClass = `${styles.body2} ${extraClass} ${
		error ? styles.error : ""
	} ${fontType === "semibold" ? styles.semibold : ""} ${
		fontStyle === "italic" ? styles.italic : ""
	} ${isLink ? styles.link : ""} `;

	return (
		<>
		<Typography className={customClass} onClick={handleClick}>
			<div style={{display: 'flex', flexDirection:'row', justifyContent: 'space-between'}}>
				<div>{text}</div>
				{enableInfo && <Tooltip title={infoText}>
					<InfoRoundedIcon color="info" fontSize="small" />
				</Tooltip>}
			</div>
		</Typography>
		
		</>
	);
};

export default Body2;
